import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import { dashboardAlertsQuery, dashboardRemainderQuery } from "@/lib/appQueries";

export function useDashboardAlerts() {
  const { isSignedIn } = useAuth();
  return useQuery({
    ...dashboardAlertsQuery,
    enabled: isSignedIn === true,
  });
}

export function useDashboardRemainder() {
  const { isSignedIn } = useAuth();
  return useQuery({
    ...dashboardRemainderQuery,
    enabled: isSignedIn === true,
  });
}
